import { NOT_REQUIRED_ACCESS_TOKEN_APIS } from '../../../constants/gatewayConstants';
var isRequiredAccessTokenApi = function (urlPath) {
    return NOT_REQUIRED_ACCESS_TOKEN_APIS.filter(function (path) { return urlPath.includes(path); }).length === 0;
};
export default isRequiredAccessTokenApi;
